module.exports = __webpack_public_path__ + "img/homepage_hero_image.c0df500c.webp";